import * as React from 'react';
import {useAuth} from '@/context/AuthContext.tsx';
import {useLocation, useNavigate} from 'react-router-dom';
import {notify} from "@/components/Notifications.tsx";

import kosmosLogo from '@/assets/kosmos-logo-white.png';

export default function LoginPage() {
    const {login} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as any)?.from?.pathname as string | undefined;

    const [loading, setLoading] = React.useState(false);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            const fd = new FormData(e.currentTarget);
            const email = String(fd.get('email') ?? '');
            const password = String(fd.get('password') ?? '');
            const user = await login(email, password);

            // notify.success(`Welcome back, ${user.username}!`);
            navigate('/', {replace: true});
        } catch (err: any) {
            notify.error("Login failed: " + (err?.response?.data?.message || err.message || err.toString()));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="min-h-screen bg-gray-800">
                <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <img
                            alt="Kosmos 94.1 Logo"
                            src={kosmosLogo}
                            className="mx-auto h-12 w-auto"/>
                        <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-white">Sign in to your
                            account</h2>
                    </div>

                    <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                        <div
                            className="bg-gray-800/50 px-6 py-12 outline -outline-offset-1 outline-white/10 sm:rounded-lg sm:px-12">
                            <form onSubmit={onSubmit} className="space-y-6">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-white">
                                        Email address
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            required
                                            autoComplete="email"
                                            className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-blue-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-800 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="password" className="block text-sm/6 font-medium text-white">
                                        Password
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            required
                                            autoComplete="current-password"
                                            className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-blue-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-800 sm:text-sm/6"
                                        />
                                    </div>
                                </div>


                                <div>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="flex w-full justify-center rounded-md bg-blue-800 px-3 py-1.5 text-sm/6 font-semibold text-white hover:bg-indigo-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                                    >
                                        {loading ? 'Signing in…' : 'Sign in'}
                                    </button>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
